import { createContext } from 'react';
import emptyFunction from 'react-utils/emptyFunction';
import { NAV } from 'chatspot-core/types/LayoutVariants';
export const DEFAULT_SECTION_CONTEXT = {
  getIsUngated: () => false,
  getHasScope: () => false,
  disableThoughts: false,
  isWaitingForChatResponse: false,
  layoutSize: 'LG',
  variant: NAV,
  onCopilotActionClicked: emptyFunction,
  onCopilotActionV2Clicked: emptyFunction,
  onBreezeActionClicked: emptyFunction,
  onLinkActionClicked: emptyFunction,
  onTemplateActionClicked: emptyFunction,
  onThoughtsClicked: emptyFunction,
  allowedImageHosts: undefined,
  disableAnimations: false,
  appAuthAvailable: true
};
export const SectionContext = /*#__PURE__*/createContext(DEFAULT_SECTION_CONTEXT);